import { Button } from "@/shared/components/ui/button";
import { Card } from "@/shared/components/ui/card";
import { Checkbox } from "@/shared/components/ui/checkbox";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { Input } from "@/shared/components/ui/input";
import type { ControlPanelGrantGroup, ControlPanelUserModalMode, UpsertControlPanelUserDto } from "../types/controlPanelUser";

interface Props {
    open: boolean;
    mode: ControlPanelUserModalMode;
    grantGroups: ControlPanelGrantGroup[];
    value: UpsertControlPanelUserDto;
    onChange: (next: UpsertControlPanelUserDto) => void;
    onToggleGroup: (groupId: number) => void;
    onCancel: () => void;
    onSubmit: () => void;
}

export function ControlPanelUserDialog(props: Props) {
    return (
        <Dialog open={props.open} onOpenChange={(open) => !open && props.onCancel()}>
            <DialogContent className="max-w-xl">
                <DialogHeader>
                    <DialogTitle>{`Control Panel User ${props.mode}`}</DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <div className="space-y-2">
                        <div className="text-sm font-medium">유저 이메일</div>
                        <Input
                            value={props.value.userEmail}
                            onChange={(e) => props.onChange({ ...props.value, userEmail: e.target.value })}
                            maxLength={128}
                        />
                    </div>

                    <div className="space-y-2">
                        <div className="text-sm font-medium">유저 권한 그룹</div>
                        <Card className="p-3 max-h-[150px] overflow-y-auto">
                            <div className="space-y-2">
                                {props.grantGroups.map((g) => {
                                    const checked = props.value.grantGroupIds.includes(g.id);
                                    return (
                                        <label key={g.id} className="flex items-center gap-2 text-sm cursor-pointer">
                                            <Checkbox checked={checked} onCheckedChange={() => props.onToggleGroup(g.id)} />
                                            <span>{g.name}</span>
                                        </label>
                                    );
                                })}
                            </div>
                        </Card>
                    </div>
                </div>

                <DialogFooter>
                    <Button variant="ghost" onClick={props.onCancel}>
                        취소
                    </Button>
                    <Button onClick={props.onSubmit}>{props.mode}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}